export default __webpack_public_path__ + "static/media/bitterroot.ed9d24a6.png";